import type { ReactNode } from 'react'

export function StatusBadge({ tone = 'neutral', children }: { tone?: string; children: ReactNode }) {
  return <span className={`status-badge status-${tone}`}>{children}</span>
}
